module.exports = __webpack_public_path__ + "static/media/kickstart_logo.5c5e95f3.jpeg";